
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d384b9e0\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/www/newcode/platform-admin/src/style/theme.scss\",\"/data/www/newcode/platform-admin/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./shoplogin.vue")
require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d384b9e0\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/www/newcode/platform-admin/src/style/theme.scss\",\"/data/www/newcode/platform-admin/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./shoplogin.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./shoplogin.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d384b9e0\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./shoplogin.vue"),
  /* scopeId */
  "data-v-d384b9e0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/shoplogin.vue
// module id = 965
// module chunks = 30